<template>
  <div>
    <div class="section-title">{{ $t('stock.currentStock') }}</div>
    <section class="section stock">
      <div class="table-responsive">
      <table class="stock-table table table-sm">
        <thead>
          <tr>
            <th scope="col" class="name">{{ $t('stock.item') }}</th>
            <th scope="col" class="branch">{{ $t('stock.branch') }}</th>
            <th scope="col" class="stock">{{ $t('stock.quantity') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="items.length === 0">
            <td :colspan="3">
              <div class="stock-empty">{{ $t('stock.emptyData') }}</div>
            </td>
          </tr>
          <template v-else>
            <tr
              v-for="item in items"
              :key="`item-${item.store}-${item.title}`"
            >
              <td class="name">{{ item.title }}</td>
              <td class="branch">{{ item.store }}</td>
              <td class="stock">
                {{ Number(item.stock).toLocaleString() }} {{ $tc('stock.unit', Number(item.stock) || 0) }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="stock-desc">{{ $t('stock.desc') }}</div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'StockTable',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>

<style lang="sass" scoped>
.section-title
  margin: 24px 24px 8px

  color: #686868
  font-size: 0.875rem
  font-weight: bold
  letter-spacing: 2px
  text-transform: uppercase

  & + .section
    margin-top: 0

  &-container
    display: flex
    align-items: center
    margin: 24px 24px 8px

    & + .section
      margin-top: 0

    .section-title
      flex-grow: 1
      margin: 0

.stock
  padding: 0 16px 24px

  &-table
    th, td
      padding: 8px 16px

      vertical-align: middle

    th.name,
    th.branch,
    th.stock
      font-weight: normal
      font-size: 0.75rem
      color: #8E8E8E

    th.branch,
    td.branch
      text-align: center

    th.stock,
    td.stock
      text-align: right

    td.branch,
    td.stock
      font-size: 0.875rem

    th.branch,
    th.stock
      min-width: 25%

  &-empty
    padding: 24px 0
    font-size: 0.75rem
    color: #8E8E8E
    text-align: center

  &-desc
    font-size: 0.75rem
    color: #8E8E8E
    text-align: center
</style>
